export default "__VITE_ASSET__BVctr2VE__"